import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../service/Api";

export const getMedallions = createAsyncThunk(
    "medallion/getMedallions",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await Api.get("/list_meddlion", { params: payload });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to get medallions" }
            );
        }
    }
);